import React from 'react';
import { map, upperFirst, get } from 'lodash';
import cn from 'classnames';
import { useIntl } from 'react-intl';

import { Icon } from 'components';
import type { ZoneLocation, WidgetType } from '../../../types';
import { MAPPING_ZONE, MAPPING_PERIOD } from '../../../constants';
import fireGlyph from 'assets/svg/fire.svg';
import './header.scss';

interface Props {
    widgetType: WidgetType;
    zoneLocations: ZoneLocation[];
    activeZoneLocation: ZoneLocation | undefined;
    makeHandleChangeZoneLocation: (zoneLocation: ZoneLocation) => VoidFunction;
}

const Header: React.FC<Props> = ({
    zoneLocations,
    widgetType,
    activeZoneLocation,
    makeHandleChangeZoneLocation,
}) => {
    const { formatMessage } = useIntl();

    const period = get(MAPPING_PERIOD, widgetType, undefined);

    return (
        <div styleName="container">
            <Icon styleName="icon" glyph={fireGlyph} />

            <div styleName="type">
                {period ? formatMessage(period) : widgetType}
            </div>

            <div styleName="categories">
                {map(zoneLocations, location => {
                    const title = get(MAPPING_ZONE, location, undefined);

                    return (
                        <div
                            styleName={cn('category', {
                                active: activeZoneLocation === location,
                            })}
                            onClick={makeHandleChangeZoneLocation(location)}
                            key={location}
                        >
                            {upperFirst(
                                title ? formatMessage(title) : location
                            )}
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default Header;
